import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import IconButton from "@mui/material/IconButton";
import type {ColumnDef, Row, RowData} from "@tanstack/react-table";
import {useTranslation} from "react-i18next";

export const SERVER_TABLE_EXPANSION_COLUMN_ID = "__expansion";
export const SERVER_TABLE_EXPANSION_COLUMN_WIDTH = 44;

const ServerTableExpansionCell = <TData extends RowData>({
    row
}: {
    row: Row<TData>
}) => {
    const {t} = useTranslation();

    if (!row.getCanExpand()) {
        return row.depth > 0
            ? <SubdirectoryArrowRightIcon sx={{fontSize: 18, color: "text.disabled"}}/>
            : null;
    }

    const expanded = row.getIsExpanded();

    return (
        <IconButton
            size="small"
            aria-label={t(expanded ? "Collapse row" : "Expand row")}
            aria-expanded={expanded}
            onClick={row.getToggleExpandedHandler()}
            sx={{p: 0.5}}
        >
            {expanded
                ? <KeyboardArrowDownIcon fontSize="small"/>
                : <KeyboardArrowRightIcon fontSize="small"/>}
        </IconButton>
    );
};

export const createServerTableExpansionColumn = <TData extends RowData>(): ColumnDef<TData, unknown> => ({
    id: SERVER_TABLE_EXPANSION_COLUMN_ID,
    header: () => null,
    cell: ({row}) => <ServerTableExpansionCell row={row}/>,
    size: SERVER_TABLE_EXPANSION_COLUMN_WIDTH,
    minSize: SERVER_TABLE_EXPANSION_COLUMN_WIDTH,
    maxSize: SERVER_TABLE_EXPANSION_COLUMN_WIDTH,
    enablePinning: false,
    enableResizing: false,
    enableSorting: false,
    meta: {align: "center"}
});
